import * as Yup from 'yup';

import { SelectPartnerFormValues } from '../types';

const selectPartnerValidation = Yup.object()
    .shape({
        partner: Yup.string(),
        partnerOfPartner: Yup.string(),
        country: Yup.string().required('Country is required'),
    })
    .test('at-least-one', function (value: SelectPartnerFormValues) {
        if (!value) return true;

        const hasPartner = Object.prototype.hasOwnProperty.call(value, 'partner');
        const hasPartnerOfPartner = Object.prototype.hasOwnProperty.call(value, 'partnerOfPartner');

        const { partner, partnerOfPartner } = value;

        if (hasPartner && !partner) {
            return this.createError({
                path: 'partner',
                message: 'Select Partner',
            });
        }
        if (!hasPartner && hasPartnerOfPartner && !partnerOfPartner) {
            return this.createError({
                path: 'partnerOfPartner',
                message: 'Select Partner of Partner',
            });
        }
        return true;
    });

export { selectPartnerValidation as default };
